import React from 'react'
import PropTypes from 'prop-types'
import { ErrorMessage } from 'formik'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const PhoneInputComponent = ({
  field,
  handleChange, // { name, value, onChange, onBlur }
  form: { touched, errors, isSubmitting, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
}) => {
  const onValueChange = (phone, extra) => {
    // if (e.target.value && e.target.value.length > 12) {
    //   e.target.value = e.target.value.slice(0, 13);
    // }
    const { dialCode } = extra

    setFieldValue('phonePrefix', dialCode)
    setFieldValue('phone', phone)
  };


  return(
  <div>
    {
        <PhoneInput
        country={'sg'}
        {...field}
        onChange={onValueChange}
        inputProps={{
          name: field.name,
          onBlur: field.onBlur,
        }}
        />
    }
    <ErrorMessage {...field} />
  </div>
)
  }

PhoneInputComponent.propTypes = {
  filed: PropTypes.object,
  form: PropTypes.object,
}

export default PhoneInputComponent
